<template>
  <div v-if="permission" class="inline">
    <slot />
    <div v-if="showMessage">
      <div class="container">
        <p class="lead text-center">
          {{ t("components.AccessRightWrapper.message") }}
        </p>
      </div>
    </div>
  </div>
  <slot v-else name="not" />
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { type PropType, computed } from "vue";
import { hasConfiguredAccessRight } from "@/functions/accessRightHelper";

const props = defineProps({
  right: {
    type: String,
    required: false,
    default: null,
  },
  rights: {
    type: Array as PropType<string[]>,
    required: false,
    default: null,
  },
  not: {
    type: Boolean,
    required: false,
    default: false,
  },
  some: {
    type: Boolean,
    required: false,
    default: false,
  },
  showMessage: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const permission = computed(() => {
  let permitted = true;
  // If rights are given, check them (else return false)
  if (props.right || props.rights) {
    let rights = props.rights?.filter((right) => right.trim() !== "");
    // If only one right is given (and no array provided), create a 1-element array (so we can process it the same way as an array of rights)
    if (props.right && !props.rights) {
      rights = [props.right];
    }
    if (props.some) {
      // Check if the user has some rights (OR)
      permitted = rights.some(hasConfiguredAccessRight);
    } else {
      // Check if user has all the requested rights (AND) (default case)
      permitted = rights.every(hasConfiguredAccessRight);
    }
  }
  // Check if we should invert the result (and do so if requested)
  return props.not ? !permitted : permitted;
});

const { t } = useTranslation();
</script>

<style scoped>
.inline {
  display: contents;
}
</style>
